import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SafeHtml} from '@angular/platform-browser';
import {MxButtonModel, MxButtonsConfig} from '../../../mx-button/components/mx-button.model';

export class MxConfirmDialogData {
    title?: string;
    message?: string | SafeHtml;
    type?: 'error' | 'warn' | 'accent' | 'info' = 'info';
    isAlert: boolean = false;
    contentType?: 'json' | 'iframe' | 'html' = 'html';
    closeLabel?: string;
    okLabel?: string;
    actionButtons?: MxButtonsConfig = new MxButtonsConfig();
}

@Component({
    selector: 'mx-confirm-dialog',
    standalone: false,
    templateUrl: './mx-confirm-dialog.component.html',
})

export class MxConfirmDialogComponent implements OnInit {
    public closeButton: MxButtonModel;
    public okButton: MxButtonModel;
    public actionButtons: MxButtonsConfig;

    constructor(
        private dialogRef: MatDialogRef<MxConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MxConfirmDialogData
    ) {
        this.actionButtons = Object.assign({}, new MxButtonsConfig(), data.actionButtons);
    }

    ngOnInit(): void {
        this.closeButton = {
            label: this.data.closeLabel || 'Close',
            tooltip: this.data.closeLabel || 'Close',
            className: 'mxs-button--secondary',
            hidden: this.data.isAlert,
            clickHandler: () => this.dialogRef.close(false)
        };
        this.okButton = {
            label: this.data.okLabel || 'Ok',
            tooltip: this.data.okLabel || 'Ok',
            className: 'mxs-button--primary',
            clickHandler: () => {
                this.dialogRef.close(true);
            }
        };
    }
}
